<template>
  <result-page :initParams="initParams" :result="result" :backUrl="backUrl" :reportUrl="reportUrl" />
</template>


<script>
  import ResultPage from './ResultPage'
  import calculationService from "../api/calculationService";

  export default {
    props: {
      calculationId: null
    },

    computed: {
      backUrl() {
        return `/tila/${this.calculationId}`
      },
      reportUrl() {
        return `/laskuri/localapi/report/room/${this.calculationId}`
      }
    },

    data() {
      return {
        result: null,
        initParams: null
      };
    },

    created () {
      calculationService.getCalculationResult('room', this.calculationId)
        .then(result => this.result = result)

      calculationService.getCalculationInitParams('room', this.calculationId)
        .then(initParams => this.initParams = initParams)
    },

    components: {
      ResultPage
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RoomResultPage.vue